import {
  emailSchema,
  requiredErrorMessage,
  requiredNameSchema,
} from '@common/schema';
import * as yup from 'yup';

export const createUserSchema = yup.object().shape({
  email: emailSchema.required(requiredErrorMessage),
  firstName: requiredNameSchema,
  lastName: requiredNameSchema,
  suffix: yup.string().optional(),
  title: yup.string().optional(),
  role: yup
    .string()
    .oneOf([
      'super_admin',
      'organization_admin',
      'partner_admin',
      'user_admin',
      'wellness_coordinator',
      'care_navigator',
      'care_manager',
      'pharmacist',
      'data_analyst',
      'reporter',
      'quality_assurance',
      'organization_supervisor',
      'operations_coordinator',
      'partner_supervisor',
      'buildings_manager',
      'executive_reporter',
    ])
    .required(requiredErrorMessage),
  recordId: yup.string().required(requiredErrorMessage),
  supervisor_id: yup.string().optional(),
  teamId: yup.string().optional(),
});
